import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/tipoGasto';
import Tipos from './tipoGastoList';


const ms2p = (state) => {
  return {
    ...state.proyecto_tipo_gasto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipos);
